
import { hooks } from 'botframework-webchat-component';
import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { setTextToSearch } from "../../../../store/cardTextSlice";
import { openOrCloseModal } from "../../../../store/modalActionsSlice";

import './PromptButton.css';
import { ModalType } from "../../../../constants/enums";
import { Button } from 'react-bootstrap';
import StarsIcon from "../../../../Assets/chat/chat.png";
import { hide ,show} from '../Home/homeVisibilitySlice';

// const { useSendBoxValue } = hooks

function PromptButton(props: { cardText: string }) {
  let homeVisibility = useSelector((state: any) => state.homeVisibility.value);

  let dispatch = useDispatch()
  // const [sendBoxValue, setSendBoxValue] = useSendBoxValue();

  if(typeof props.cardText == "string" && props.cardText !== ""){
    // setSendBoxValue(props.cardText)
    dispatch(setTextToSearch(''));

  }

  const handleClick = useCallback(() => {
    if (homeVisibility) {
      dispatch(hide());
    } else {
      dispatch(show());
    }
  }, [dispatch, homeVisibility]);

  return (
    <div className="prompts-button-container">
      <Button onClick={handleClick} type="button"  className='prompts-button'>
        <span><img src={StarsIcon} alt="" /></span> FAQ
      </Button>
    </div>
  );
}

export default memo(PromptButton);
